import React from "react";
import { Link } from "react-router-dom";
import WEB from "../assets/web.png";
import FB from "../assets/fb.png";
import IG from "../assets/ig.png";
import TW from "../assets/tw.png";
import YT from "../assets/yt.png";
function Footer() {
  return (
    <footer className="w-full bg-white   px-4">
      <div className="container flex flex-wrap justify-center items-center py-1 mx-auto">
        <a target="_blank" href="https://fasesl.com/" className="flex items-center mx-4 my-1 hover:scale-105 transform transition-all hover:duration-500 ease-in-out" rel="noreferrer">
          <img src={WEB} alt="FASE" className=" w-6 h-6 object-center object-contain mr-2" />
          <p className="">fasesl.com</p>
        </a>
        <a target="_blank" href="https://www.instagram.com/fase.srilanka/" className="flex items-center mx-4 my-1 hover:scale-105 transform transition-all hover:duration-500 ease-in-out" rel="noreferrer">
          <img src={IG} alt="FASE" className="h-5 object-center object-contain mr-2" />
          <p className="">fase.srilanka</p>
        </a>
        <a target="_blank" href="https://www.facebook.com/faselk" className="flex items-center mx-4 my-1 hover:scale-105 transform transition-all hover:duration-500 ease-in-out" rel="noreferrer">
          <img src={FB} alt="FASE" className="h-5 object-center object-contain mr-2" />
          <p className="">faselk</p>
        </a>
        <a target="_blank" href="https://www.youtube.com/@fasesrilanka6998" className="flex items-center mx-4 my-1 hover:scale-105 transform transition-all hover:duration-500 ease-in-out" rel="noreferrer">
          <img src={YT} alt="FASE" className="h-5 object-center object-contain mr-2" />
          <p className="">FASE Sri Lanka</p>
        </a>
        <a target="_blank" href="https://twitter.com/AstroFASE" className="flex items-center mx-4 my-1 hover:scale-105 transform transition-all hover:duration-500 ease-in-out" rel="noreferrer">
          <img src={TW} alt="FASE" className="h-5 object-center object-contain mr-2" />
          <p className="">AstroFASE</p>
        </a>
      </div>
    </footer>
  );
}

export default Footer;
